export const TEMPLATE_WEB_OPTIONS = {
  DEFAULT: 'default',
  RETRO: 'retro',
  ANIMAL: 'animal',
  SPRINT: 'sprint',
  ONLY: 'only',
};
